export default __webpack_public_path__ + "static/media/EM0400.34I-22654_-15116_0.ad92f2d2.jpg";